import React from "react";

interface ImageTargetPreviewProps {
  image: {
    url: string;
    alt: string;
  };
}

const ImageTargetPreview = ({ image }: ImageTargetPreviewProps) => {
  return (
    <div className="relative rounded-lg overflow-hidden border border-border/50 bg-muted/30">
      <div className="aspect-[3/2] relative">
        <img
          src={image.url}
          alt={image.alt}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 bg-background/80 backdrop-blur-sm text-xs px-2 py-1 rounded text-muted-foreground">
          Revealed
        </div>
      </div>
    </div>
  );
};

export default ImageTargetPreview;
